import styled from 'vue-styled-components';

import { GRAY, applyHoverAndPress, square } from '@styles/common.styled';

import OrderAscIcon from '@svgIcons/dashboard/order-ascending.svg';

import { FLEX_CENTER_DIV } from '@styles/common.styled.component';
import { mapState } from 'vuex';

export default {
    name: 'ToTop',
    computed: {
        ...mapState('newDashboard', ['showTopBtn']),
    },
    render() {
        if (!this.showTopBtn) return null;

        return (
            <Wrapper onClick={scroll} class="to-top-wrapper">
                <OrderAscIcon v-view-box />
                <span>{this.$t('NEW_DASHBOARD.top')}</span>
            </Wrapper>
        );
    },
};

function scroll() {
    const isFunc = R.is(Function);

    Array.from(document.querySelectorAll('*'))
        .filter((node) => node && isFunc(node.scrollTo))
        .forEach((node) => node.scrollTo(0, 0));
}

const Wrapper = styled(FLEX_CENTER_DIV)`
    flex-direction: column;
    position: fixed;
    ${square(60)};
    border-radius: 50%;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.2);
    ${applyHoverAndPress('white', 'background-color')};
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    transition: all 0.2;
    z-index: 12;

    svg {
        ${square(20)};
        fill: ${GRAY(80)};
    }

    span {
        font-size: 13px;
        font-weight: 600;
        color: ${GRAY(80)};
    }
`;
